






























































































































































































































































































































import Vue from "vue";
import FilteringMain from "@/components/FilteringMainv2.vue";
import MapCircleButton from "@/components/MapCircleButton.vue";
import ModesColors from "@/constants/travelModesColors";
import OutlineColors from "@/constants/outlineColors";
import UsersColors from "@/constants/usersColors";
import ApiService from "../services/ApiService";
import { getGoogleMapsAPI } from "gmap-vue";
// import { debounce } from "vue-debounce";
export default Vue.extend({
  data() {
    return {
      gmap: null,
      school_addresses: [],
      trackingMarkers: [],
      selection: "",
      modesSelection: [
        "CAR",
        "TRAIN",
        "BUS",
        "WALKING",
        "BICYCLING",
        "CARPOOL",
        "TAXI",
        "SCHOOL_BUS",
      ],
      colors: {},
      userTypeColors: {},
      outlineColors: {},
      category: "",
      categoryTitle: "",
      zoom: 10,
      radius: 20,
      schoolIconZoomCoef: 1,
      modesCirclesZoomCoef: 1,
      loading: false,
      filterOptions: { school_ids: [] },
      showSchoolIds: [],
      center: { lat: 51.5074, lng: 0.1278 },
      travelMarkers: [],
      markers: [],
      categoryToTitle: {
        modes_of_travel_map: "School Commute Travel Modes",
        user_base_map: "User Base",
        parking_locations_map: "Parking Locations",
      },
      accColor: {
        0: "red",
        1: "green",
      },
      currentZoom: 11.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,
      maxZoom: 13,
      gridData: [
        {
          type: "School Commute Travel Modes",
          description:
            "See how parents and staff are travelling to school. The markers represent journey start points, colour coded to represent the primary travel mode used.",
        },
        {
          type: "User Base",
          description: "See your school catchment.",
        },
        {
          type: "Parking Locations",
          description:
            "See where parents and staff that drive to school, usually park or drop off.",
        },
      ],
      student_id: null,
      tracking_id: null,
      selected_terms_id: null,
      new_travel_mode: null,
      timeout: null,
      mapStyle: {
        // other properties...
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#263c3f" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#6b9a76" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#2f3948" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      },
    };
  },
  components: {
    FilteringMain,
    // LMarker,
    // LPopup,
    // LTooltip,
    MapCircleButton,
  },
  methods: {
    updateMainFilter(data) {
      this.filterOptions = data;
      this.showSchoolIds = data.school_ids ? data.school_ids : [];
      this.getMarkers();
      // this.loading = false;
      // debounce(() => this.getMarkers(), 400);
    },
    toggleMode(mode) {
      if (this.modesSelection.indexOf(mode) > -1) {
        const index = this.modesSelection.indexOf(mode);
        this.$delete(this.modesSelection, index);
        this.$forceUpdate();
      } else {
        this.modesSelection.push(mode);
      }
      this.getMarkers();
    },
    goto(category) {
      this.$router.push("/members/maps/" + category);
      this.category = category;
      if (this.category === "parking_locations_map") {
        this.maxZoom = 15;
      } else {
        this.maxZoom = 13;
      }
      if (this.accType == "SUPERADMIN") {
        this.maxZoom = 18;
      }
      this.categoryTitle = this.categoryToTitle[category];
      this.getMarkers();
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    zoomChanged(zoom) {
      this.schoolIconZoomCoef = zoom > 10 ? 1 : 0.7;
      this.modesCirclesZoomCoef = this.modesCirclesZoomCoefBasedOnZoom(zoom);
      this.zoom = zoom;
    },
    modesCirclesZoomCoefBasedOnZoom(zoom) {
      const values = {
        8: 2,
        9: 1.5,
        10: 1,
        11: 0.65,
        12: 0.5,
        13: 0.45,
        14: 0.3,
        15: 0.25,
        16: 0.15,
        17: 0.1,
        18: 0.05,
      };
      if (values[zoom]) {
        return values[zoom];
      } else {
        return 1;
      }
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    getSchools() {
      ApiService.generalApi.getOrgsWithAddress().then((response: any) => {
        const allSchools = response.data.schools
          ? response.data.schools
          : response.data;
        const addresses = [];
        if (allSchools) {
          allSchools.forEach((item) => {
            if (item.address) {
              item.address.forEach((address) => {
                addresses.push({
                  lat: parseFloat(address.latitude),
                  lng: parseFloat(address.longitude),
                  school_id: item.id,
                  name: item.name,
                });
              });
            }
          });
        }
        this.school_addresses = [...addresses];
      });
    },
    getMarkers() {
      const payload = this.getPayload();
      if (
        this.category === "modes_of_travel_map" &&
        this.modesSelection.length === 0
      ) {
        this.$message({
          type: "warning",
          message: "Select at least 1 travel mode",
        });
        this.markers = [];
        this.travelMarkers = [];
        return;
      }
      this.markers = [];
      this.travelMarkers = [];
      this.loading = true;
      ApiService.generalApi
        .getMarkers(payload)
        .then((resp) => {
          if (this.category === "modes_of_travel_map") {
            this.travelMarkers = this.convertToLatLng(resp.data.journeys);
          } else if (this.category === "user_base_map") {
            this.markers = this.convertToLatLng(resp.data.journeys);
          } else if (this.category === "parking_locations_map") {
            this.markers = this.convertToLatLng(resp.data.parkings);
          }
          if (resp.data.school_ids) {
            this.showSchoolIds = resp.data.school_ids;
            this.$forceupdate();
          }
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    },
    test(param) {
      alert(param);
    },
    showMarkers() {
      if (this.student_id) {
        ApiService.sadminApi.getStudentMarkers(this.student_id).then((resp) => {
          this.trackingMarkers = resp.data.map((item) => {
            item.lat = parseFloat(item.lat);
            item.lng = parseFloat(item.lng);
            return item;
          });
        });
      } else if (this.tracking_id) {
        ApiService.sadminApi.getJourney(this.tracking_id).then((resp) => {
          this.trackingMarkers = resp.data.map((item) => {
            item.lat = parseFloat(item.lat);
            item.lng = parseFloat(item.lng);
            return item;
          });
        });
      }
    },
    getPayload() {
      return {
        ...this.filterOptions,
        journeyMarkers: this.modesSelection,
      };
    },
    convertToLatLng(markers) {
      const returnMarkers = [];
      let temp;
      markers.forEach((element) => {
        temp = element.latLng.split(",");
        if (temp.length == 2) {
          if (element.type) {
            element.type = element.type.toLowerCase();
            // if (
            //   element.type == "car" &&
            //   this.modesSelection.indexOf("CARPOOL") > -1 &&
            //   element.is_shared == 1
            // ) {
            //   element.type = "carpool";
            // }
          }

          element.location = {
            lat: parseFloat(temp[0]),
            lng: parseFloat(temp[1]),
          };
          element.id = element.t_id;
          returnMarkers.push(element);
        }
      });
      if (returnMarkers.length > 0) {
        this.center = returnMarkers[0].location;
        if (this.category == "parking_locations_map") {
          // this.zoom = 14;
        } else {
          // this.zoom = 11;
        }
      }
      // console.log("Markers HERE", returnMarkers);
      return returnMarkers;
    },
    showTravelInfo(id) {
      this.selected_terms_id = id;
    },
    changeMode() {
      ApiService.sadminApi
        .changeTravelMode({
          terms_archive_id: this.selected_terms_id,
          new_travel_mode: this.new_travel_mode,
        })
        .then(() => {
          this.$notify.info({
            title: "Journey changed",
          });
          this.selected_terms_id = null;
          this.timeout = setTimeout(() => {
            this.getMarkers();
          }, 200);
        });
    },
  },
  computed: {
    accType: function () {
      return this.$store.state.accType;
    },
    // accType() {
    //   if (!this.$store.state.user) {
    //     return null;
    //   }
    //   if (this.$store.state.user.domain) {
    //     return this.$store.state.user.domain.name;
    //   } else {
    //     return this.$store.state.user.admin_type.name;
    //   }
    // },
    unread() {
      return this.$store.state.unread_messages;
    },
    // native() {
    //   return !this.$store.state.general.native;
    // }
  },
  mounted() {
    // console.log("Colors", ModesColors);
    this.colors = ModesColors;
    this.outlineColors = OutlineColors;
    this.userTypeColors = UsersColors;
    // this.accType = this.$store.state.user.admin_type.name;
    this.category = this.$route.params.category;
    this.categoryTitle = this.categoryToTitle[this.category];
    this.getSchools();
    if (this.accType == "SUPERADMIN") {
      this.maxZoom = 18;
    }
    // this.google.maps.Map(document.getElementById("container"), {
    //   mapId: "8e0a97af9386fef",
    //   center: { lat: 50, lng: 1 },
    //   zoom: 12,
    // });
    setTimeout(() => {
      // const g = getGoogleMapsAPI();
      // console.log("thisg", g);
      // const map = new g.maps.Map(document.getElementById("mapContainer"), {
      //   mapId: "accfc72fe6b2bc0b",
      //   center: { lat: 50, lng: 2 },
      //   zoom: 12,
      // });
      // mapId: "8e0a97af9386fef",
      // const map = new g.maps.Map(document.getElementById("mapContainer"), {
      //   mapId: "8e0a97af9386fef",
      //   center: { lat: 48.85, lng: 2.35 },
      //   zoom: 12,
      // });
    }, 1500);
  },
  beforeDestroy() {
    this.timeout = null;
  },
});
